import React, { useState, useEffect } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function PopupRender({ node, isLiveMode, children }) {
  const content = node.content || {};
  const triggerSelector = content.triggerSelector || '.open-popup';
  const showInEditor = content.showInEditor === 'true';
  const width = content.width || '600px';
  const bgColor = content.bgColor || '#1e293b';

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isLiveMode) return;
    
    const handleGlobalClick = (e) => {
      // Prüfen, ob der Klick auf ein Element mit dem passenden Selektor stattfand
      // (z.B. ein Button <a class="open-popup" ...>)
      if (e.target.closest && e.target.closest(triggerSelector)) {
        e.preventDefault();
        setIsOpen(true);
      }
    };
    
    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, [isLiveMode, triggerSelector]);

  // Im Editor steuern wir die Sichtbarkeit manuell über den Inspector
  // Im Live-Modus hängt es vom State ab
  const show = isLiveMode ? isOpen : showInEditor;

  if (!show) {
    if (isLiveMode) return null; // Im echten Frontend komplett ausblenden!
    // Im Editor zeigen wir einen Platzhalter, damit man das Widget im Canvas noch anklicken kann
    return (
      <div style={{ 
        padding: '12px', 
        background: 'rgba(255,165,0,0.1)', 
        border: '1px dashed orange',
        color: 'orange',
        textAlign: 'center',
        margin: '10px 0',
        borderRadius: '8px'
      }}>
        🚨 <strong>Popup-Modul</strong> (Ausgeblendet).<br/>
        Aktiviere "Zeige im Editor" im rechten Seitenmenü, um Inhalte hineinzuziehen.<br/>
        <small>Trigger-Selektor: <code>{triggerSelector}</code></small>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.8)',
      zIndex: 9999, // Maximal im Vordergrund
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'auto',
      backdropFilter: 'blur(4px)' // Glassmorphism für den Hintergrund
    }}>
      <div style={{
        width: width,
        maxWidth: '90%',
        minHeight: '200px',
        maxHeight: '90vh',
        overflowY: 'auto',
        background: bgColor,
        borderRadius: '16px',
        padding: '24px',
        position: 'relative',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(255,255,255,0.05)'
      }}>
        <button 
          onClick={() => setIsOpen(false)}
          style={{ 
            position: 'absolute', top: '16px', right: '16px', 
            background: 'rgba(255,255,255,0.1)', border: 'none', 
            borderRadius: '50%', color: '#fff', fontSize: '20px', 
            width: '32px', height: '32px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >×</button>
        
        {children && children.length > 0 ? (
          children
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '150px', color: '#64748b' }}>
            Ziehe Widgets (Bilder, Texte, Formulare) hier hinein.
          </div>
        )}
      </div>
    </div>
  );
}

registry.register('Popup', {
  label: 'Popup / Modal',
  icon: '🪟', 
  category: 'layout',
  component: PopupRender,
  
  defaultProps: {
    children: [], // Popups nehmen andere Widgets auf
    content: {
      triggerSelector: '.open-popup',
      showInEditor: 'false',
      width: '600px',
      bgColor: '#0f172a' // slate-900 (TEF Darkmode Palette)
    },
    style: {
      desktop: {}
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Steuerung',
          fields: [
            { name: 'content.triggerSelector', label: 'Trigger CSS-Klasse / ID', type: 'text' },
            { name: 'content.showInEditor', label: 'Im Editor öffnen / bearbeiten?', type: 'select', options: ['false', 'true'] }
          ]
        },
        {
          title: 'Design-Fenster',
          fields: [
            { name: 'content.width', label: 'Breite (z.B. 600px, 80vw)', type: 'text' },
            { name: 'content.bgColor', label: 'Hintergrundfarbe (Popup)', type: 'color' }
          ]
        }
      ]
    }
  ]
});
